<template>
  <div class="full-view"
       :style="'background-image: url(\'' + settings.staticImageUrl + '/friends.jpg\')'"
  >
    <mdb-mask class="gradient d-flex justify-content-center align-items-center overflow-auto">
      <div class="input-form">
        <mdb-card>
          <mdb-card-header>
            <h3>Online Meeting</h3>
          </mdb-card-header>
          <mdb-card-body>
            <div v-html="message"></div>

          </mdb-card-body>
        </mdb-card>
      </div>
    </mdb-mask>

  </div>
</template>
<script>
import api from '../services/groupsPlaceApi.js'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbInput, mdbMask} from 'mdbvue';

export default {
  name: "jitsi-link",
  components: {
    mdbCard, mdbCardHeader, mdbCardBody, mdbInput, mdbBtn, mdbMask
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
  },
  data() {
    return {
      message: "Checking Your Meeting Invitation"
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    let lastToken = localStorage.getItem("lastPresentationToken")
    let url = "/jitsi/guestLink/" + this.$route.params.id
    api.get(url).then(
      (results) => {
        let launchUrl = results.data.url
        launchUrl += "?jwt=" + results.data.jwtToken
        this.message = `<p>Meeting should have opened in another window/tab. If not, be sure it was not blocked by your browser. You may refresh this page to try again. Alternatively, try the button below.</p>`
                    this.message += `<p><a class="btn btn-sm btn-rounded btn-primary" href="${launchUrl}">Launch</a></p>`
        window.open(launchUrl, "_blank")
      },
      (error) => {
        if (error.response && error.response.data) this.message = error.response.data
        else this.message = "Error retrieving your invitation."
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  }
};

</script>
<style scoped>
@media screen and (max-width: 749px ) {
  .input-form {
    margin: auto;
    width: 80%;

  }
}

@media screen and (min-width: 750px ) {
  .input-form {
    margin: auto;
    width: 50%;
  }
}

.gradient {
  background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
  background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  height: calc(100vh);
}

.full-view {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh);
}



</style>
